export const MC_QUESTIONS = ['single_choice', 'dropdown', 'multiple_choice'];

export const sendMessage = (msg, domain) => {
  window.parent.postMessage(msg, domain);
};
